import { GetStaticProps } from 'next';
import { initializeApollo } from '../../utils/apollo';
import { Service, ServiceServiceDynamicDynamicZone, Technology } from '../../types/schema';
import AllServicesPageComponent from '../../components/elements/AllServicesPage';
import { flatten, translateProperty } from '../../utils/object';
import { SERVICE_PAGE } from '../../queries/services';
import PageLayout, { MenuProps } from '../../layouts/Page';
import { Error, sendError } from '../../utils/error';

export type AllServicesPageContainerProps = {
  service: Service;
  technologies: Technology[];
  menus: MenuProps;
};

const AllServicesPageContainer: React.FC<AllServicesPageContainerProps> = ({
  service,
  technologies,
  menus,
}) => {
  return (
    <PageLayout menus={menus} locale="en" isHeaderTransparent>
      <AllServicesPageComponent
        metaImage={(service?.metadata?.metaImage as unknown as { url?: string })?.url as string}
        metaTitle={service?.metadata?.metaTitle as string}
        metaDescription={service?.metadata?.metaDescription as string}
        hideAppMastersTitle={service?.metadata?.hideAppMastersTitle as boolean}
        service={service}
        serviceDynamic={service.serviceDynamic as ServiceServiceDynamicDynamicZone[]}
        technologies={technologies}
      />
    </PageLayout>
  );
};

/**
 * getStaticProps
 */
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (locale === 'pt') {
    return {
      notFound: true,
    };
  }

  try {
    const apolloClient = initializeApollo();

    const { data } = await apolloClient.query({
      query: SERVICE_PAGE,
      variables: {
        locale,
      },
    });

    const newData = flatten(data);

    const translatedObj = translateProperty(
      (newData as { service: Service }).service,
      ['background', 'textAlign', 'button', 'backgroundColor', 'content'],
      'serviceDynamic',
    );

    return {
      props: {
        service: translatedObj as Service,
        technologies: newData.allTechnologies,
        menus: {
          header: newData.header,
          technologies: newData.technologies,
          services: newData.services,
          footerPt: newData.footerPt,
          footerEn: newData.footerEn,
        },
      },
    };
  } catch (error) {
    sendError({ error: error as Error, message: 'Error on services index' });
    return {
      notFound: true,
    };
  }
};

export default AllServicesPageContainer;
